export default ({ $integrationsManager }) => {
    const integration = {
        name: 'brightedge',
    }

    $integrationsManager.add(integration)
}
